import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import RSVPModal from "../components/RSVPModal";

function EventDetails() {
  const { slug } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [rsvpOpen, setRsvpOpen] = useState(false);
  const [event, setEvent] = useState(null);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");

      try {
        const token = localStorage.getItem("authToken");
        const headers = {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };

        const eventResponse = await fetch(
          `${TEST_BASE_URL}/upcoming-event/${slug}/`,
          { headers }
        );

        if (!eventResponse.ok) {
          throw new Error(`HTTP error! Status: ${eventResponse.status}`);
        }

        const eventResult = await eventResponse.json();
        setEvent(eventResult.data);

        const upcomingResponse = await fetch(
          `${TEST_BASE_URL}/upcoming-events`,
          { headers }
        );

        if (upcomingResponse.ok) {
          const upcomingResult = await upcomingResponse.json();

          let eventsData = [];
          if (Array.isArray(upcomingResult)) {
            eventsData = upcomingResult;
          } else if (
            upcomingResult.data?.events &&
            Array.isArray(upcomingResult.data.events)
          ) {
            eventsData = upcomingResult.data.events;
          } else if (
            upcomingResult.data &&
            Array.isArray(upcomingResult.data)
          ) {
            eventsData = upcomingResult.data;
          } else if (
            upcomingResult.events &&
            Array.isArray(upcomingResult.events)
          ) {
            eventsData = upcomingResult.events;
          }

          const filteredEvents = eventsData
            .filter((e) => e.slug !== slug)
            .slice(0, 2);

          setUpcomingEvents(filteredEvents);
        }
      } catch (err) {
        console.error("Error loading event:", err);
        setError("Failed to load event details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  if (loading) {
    return (
      <section className="dashboard">
        <SideBar isOpen={sidebarOpen} />
        <div className="body-content">
          <TopBar onToggleSidebar={toggleSidebar} />
          <div className="bottom-content text-center p-5">
            <p className="text-white fs-5">Loading event details...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error || !event) {
    return (
      <section className="dashboard">
        <SideBar isOpen={sidebarOpen} />
        <div className="body-content">
          <TopBar onToggleSidebar={toggleSidebar} />
          <div className="bottom-content text-center p-5">
            <p className="text-danger fs-5">{error}</p>
          </div>
        </div>
      </section>
    );
  }
  const getSignupText = (count) => {
    const signups = parseInt(count) || 0;
    if (signups === 0) {
      return "Be the first to register for this event";
    }
    return `${signups} ${
      signups === 1 ? "MEMBER IS" : "MEMBERS ARE"
    } ATTENDING`;
  };

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />

        <div className="bottom-content">
          <div className="row">
            <div className="col-md-8">
              <div className="eventdetails">
                <p>Events</p>
                <h6>{event.title}</h6>

                {event.thumbnail ? (
                  <>
                    <img
                      src={
                        event.thumbnail.startsWith("http")
                          ? event.thumbnail
                          : `https://rccgbournemouth.org${
                              event.thumbnail.startsWith("/") ? "" : "/"
                            }${event.thumbnail}`
                      }
                      alt={event.title}
                      width="100%"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                    <div
                      className="placeholder-image"
                      style={{ display: "none" }}
                    >
                      <p>{event.title || "Image not available"}</p>
                    </div>
                  </>
                ) : (
                  <div className="placeholder-image">
                    <p>{event.title || "Image coming soon"}</p>
                  </div>
                )}

                <p dangerouslySetInnerHTML={{ __html: event.description }}></p>

                <p>
                  <b>Date:</b> {event.date || "TBA"} <br />
                  <b>Venue:</b> {event.venue || "TBA"} <br />
                  <b>Location:</b> {event.location || "TBA"} <br />
                  <b>Hosted by:</b> RCCG New Beginning Chapel
                </p>

                <div className="rsvp">
                  <button
                    onClick={() => setRsvpOpen(true)}
                    className="text-white"
                    style={{
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                    }}
                  >
                    RSVP
                  </button>

                  <span>{getSignupText(event.total_member_signups)}</span>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <h5 className="fs-5 pt-1 explore-text">Other Upcoming Events</h5>

              {upcomingEvents.length > 0 ? (
                upcomingEvents.map((item) => (
                  <div key={item.id} className="mt-3 upcomingcard">
                    {item.thumbnail ? (
                      <>
                        <img
                          src={
                            item.thumbnail.startsWith("http")
                              ? item.thumbnail
                              : `https://rccgbournemouth.org${
                                  item.thumbnail.startsWith("/") ? "" : "/"
                                }${item.thumbnail}`
                          }
                          alt={item.title}
                          width="100%"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                        <div
                          className="placeholderimage"
                          style={{ display: "none" }}
                        >
                          <p>{item.title || "Image not available"}</p>
                        </div>
                      </>
                    ) : (
                      <div className="placeholderimage">
                        <p>Image coming soon</p>
                      </div>
                    )}

                    <h6>{item.title}</h6>
                    <p className="text-white">{item.sub_title}</p>
                    <hr />
                    <div className="datediv">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            d="M17 1V3M5 1V3"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.9955 12H11.0045M10.9955 16H11.0045M14.991 12H15M7 12H7.00897M7 16H7.00897"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M2.5 7H19.5"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1.5 11.2432C1.5 6.88594 1.5 4.70728 2.75212 3.35364C4.00424 2 6.01949 2 10.05 2H11.95C15.9805 2 17.9958 2 19.2479 3.35364C20.5 4.70728 20.5 6.88594 20.5 11.2432V11.7568C20.5 16.1141 20.5 18.2927 19.2479 19.6464C17.9958 21 15.9805 21 11.95 21H10.05C6.01949 21 4.00424 21 2.75212 19.6464C1.5 18.2927 1.5 16.1141 1.5 11.7568V11.2432Z"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="text-white">{item.date}</span>
                      </div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 20 22"
                          fill="none"
                        >
                          <path
                            d="M13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 8.067 8.067 6.5 10 6.5C11.933 6.5 13.5 8.067 13.5 10Z"
                            stroke="white"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M10 1C14.8706 1 19 5.03298 19 9.92577C19 14.8965 14.8033 18.3847 10.927 20.7567C10.6445 20.9162 10.325 21 10 21C9.67495 21 9.35549 20.9162 9.073 20.7567C5.2039 18.3616 1 14.9137 1 9.92577C1 5.03298 5.12944 1 10 1Z"
                            stroke="white"
                            strokeWidth="1.5"
                          />
                        </svg>
                        <span className="text-white">{item.venue}</span>
                      </div>
                    </div>
                    <div className="whitebuttons">
                      <a href={`/eventdetails/${item.slug}`}>See Details</a>
                      <button
                        onClick={() => setRsvpOpen(true)}
                        className="text-dark"
                        style={{
                          cursor: "pointer",
                          background: "none",
                          border: "none",
                        }}
                      >
                        RSVP
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-white">
                  No other upcoming events at this time.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <RSVPModal
        isOpen={rsvpOpen}
        onClose={() => setRsvpOpen(false)}
        eventId={event?.id}
      />
    </section>
  );
}

export default EventDetails;
